import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 78 33.5",
  width: "78",
  height: "57.537",
  "xml:space": "preserve"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M32.8,32h-0.6V0.7c0-0.4-0.3-0.8-0.8-0.8H16.1c-0.4,0-0.8,0.3-0.8,0.8V32H9.8l0.7-6.1c0-0.2,0-0.4-0.2-0.6   c-0.1-0.2-0.3-0.2-0.6-0.2H7.1v-2.6c3.9-0.3,6.9-3,6.9-6.4c0-0.4-0.3-0.8-0.8-0.8c-2.5,0-4.8,1-6.1,2.6v-3.1   c2.9-0.3,5.1-2.4,5.1-4.9c0-0.4-0.3-0.8-0.8-0.8c-1.7,0-3.3,0.6-4.4,1.7V9.2c0-0.4-0.3-0.8-0.8-0.8S5.6,8.7,5.6,9.2v6.9   c-1.1-1.1-2.7-1.9-4.5-1.9c-0.4,0-0.8,0.3-0.8,0.8c0,2.8,2.3,5.1,5.2,5.4v4.7H2.9c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0.2-0.2,0.4-0.2,0.6   L2.8,32h-2C0.3,32,0,32.3,0,32.7s0.3,0.8,0.8,0.8h15.3h15.3h1.4c0.4,0,0.8-0.3,0.8-0.8S33.2,32,32.8,32z M10.6,10.8   c-0.4,1.2-1.6,2.3-3.3,2.6C7.6,12.1,8.8,11,10.6,10.8z M1.9,15.8c1.6,0.3,3.1,1.4,3.5,3.1C3.9,18.6,2.3,17.4,1.9,15.8z M12.4,16.9   c-0.4,1.9-2.4,3.7-5.2,4C7.6,19,9.6,17.2,12.4,16.9z M3.7,26.6h5.2L8.3,32h-4L3.7,26.6z M16.8,32V1.5h13.8V32H16.8z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: "M20.2,15.5C20.2,15.5,20.2,15.5,20.2,15.5c-1.1,0-1.9,0.9-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9v0   C22.1,16.4,21.2,15.5,20.2,15.5z M20.2,17.9c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h0c0.1,0,0.2,0,0.3,0.1   c0.1,0.1,0.1,0.2,0.1,0.3C20.6,17.7,20.4,17.9,20.2,17.9z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M74.7,17.1C74.7,17.1,74.7,17.1,74.7,17.1c-0.6,0-1.2,0.2-1.7,0.5v-1.8c0-1-0.4-2-1.1-2.7c-0.7-0.7-1.7-1.1-2.7-1.1   c0,0,0,0,0,0H46.9c0,0,0,0,0,0c-2.1,0-3.9,1.7-3.9,3.9v1.8c-0.5-0.3-1.1-0.5-1.8-0.5c0,0,0,0,0,0c-1.8,0-3.2,1.4-3.3,3.2v6.5   c0,1.9,1.6,3.4,3.4,3.4H43v2.5c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8v-2.5h27v2.5c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8v-2.5h1.6   c1.9,0,3.4-1.5,3.4-3.4v-6.5c0,0,0,0,0,0C78,18.6,76.5,17.1,74.7,17.1z M69.1,13.5c0.6,0,1.2,0.2,1.7,0.7c0.5,0.4,0.7,1,0.7,1.7   v4.5c0,0,0,0,0,0v3.3H58.8V13.5H69.1z M44.5,15.9c0-1.3,1.1-2.4,2.4-2.4h0h10.3v10.2H44.5v-3.3v0V15.9z M76.5,26.8   c0,1-0.9,1.9-1.9,1.9H41.4c-1,0-1.9-0.9-1.9-1.9v-6.5c0-1,0.8-1.7,1.8-1.7c0,0,0,0,0,0c1,0,1.7,0.8,1.8,1.7v4.1   c0,0.4,0.3,0.8,0.8,0.8H58c0,0,0,0,0,0s0,0,0,0h14.2c0.4,0,0.8-0.3,0.8-0.8v-4.1c0-1,0.8-1.7,1.8-1.7c0,0,0,0,0,0   c1,0,1.7,0.8,1.8,1.7V26.8z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})